import now from 'performance-now';
import { dict, get, isNil, isString } from 'ldash';
import { handleAction, handleSubState } from 'uix/actions';
import { setWebsocketState, setHTTPState, setNetworkInfo, setOnline, subscribeServerEvent, setServerEvent } from './actions';
import { WS_PING_OFFLINE } from './websocket';
import log from 'uix/logging';
export const meta = [
    handleAction(setWebsocketState, ({ netinfo, ...meta }, { payload })=>({
            ...meta,
            netinfo: {
                ...netinfo,
                ws: {
                    ...netinfo.ws,
                    ...payload
                }
            }
        }), {
        netinfo: {
            online: false,
            info: {},
            http: {
                error: false,
                roundtrip: 0
            },
            ws: {
                state: 'offline',
                roundtrip: 0
            }
        }
    }),
    handleAction(setOnline, (meta, { payload })=>({
            ...meta,
            netinfo: {
                ...meta.netinfo,
                online: payload
            }
        })),
    handleAction(setHTTPState, (meta, { payload })=>({
            ...meta,
            netinfo: {
                ...meta.netinfo,
                http: payload
            }
        })),
    handleAction(setNetworkInfo, (meta, { payload })=>({
            ...meta,
            netinfo: {
                ...meta.netinfo,
                info: payload
            }
        })),
    // API_OFFLINE detection
    handleAction(setHTTPState, (meta, { payload })=>// indirect APP_RUNNING detection via netcheck saga result
        meta.state === 'API_OFFLINE' && isNil(payload.error) ? {
            ...meta,
            state: 'APP_RUNNING'
        } : meta),
    handleAction(setWebsocketState, (meta, { payload })=>{
        // indirect if websocket goes down
        // detecting client-side network lost here
        let ws_was_online = meta.netinfo.ws.roundtrip > 0;
        let unexpected_offline = payload.state === 'offline' && meta.state === 'APP_RUNNING' && ws_was_online;
        let lost_websocket_ping = payload.roundtrip && payload.roundtrip > WS_PING_OFFLINE;
        if (unexpected_offline || lost_websocket_ping) {
            log.warn('going offline: lost-conn: %o, lost-ping: %o', unexpected_offline, lost_websocket_ping);
            return {
                ...meta,
                state: 'API_OFFLINE'
            };
        }
        return meta;
    }),
    // we get explicit signals via websockets (clean server startup/shutdowns)
    handleAction('SERVER/STARTUP', (meta, { payload })=>meta.state === 'API_OFFLINE' ? {
            ...meta,
            state: 'APP_RUNNING'
        } : meta),
    handleAction('SERVER/DEAD', (meta, { payload })=>({
            ...meta,
            state: 'API_OFFLINE'
        })),
    handleAction('SERVER/SHUTDOWN', (meta, { payload })=>({
            ...meta,
            state: 'API_OFFLINE'
        }))
];
export const data = [
    handleSubState('serverEvents', [
        handleAction('SERVER/EVENT', ({ events, ...serverEvents }, { payload, meta })=>({
                ...serverEvents,
                events: {
                    ...events,
                    [meta.eventName]: [
                        ...get(events, meta.eventName, []),
                        {
                            ...payload,
                            evt_ts: now()
                        }
                    ].slice(-(meta.max_events || 10000))
                }
            })),
        // saga is watching subscribed
        handleAction(subscribeServerEvent, ({ subscribed, ...serverEvents }, { payload })=>{
            let names = isString(payload.eventName) ? [
                payload.eventName
            ] : payload.eventName;
            let new_subscribed = dict(names.map((n)=>[
                    n,
                    payload.active
                ]));
            return {
                ...serverEvents,
                subscribed: {
                    ...subscribed,
                    ...new_subscribed
                }
            };
        })
    ], {
        subscribed: {},
        events: {}
    }),
    handleAction('SERVER/API_TIMEOUT_DATA', ({ apiTimeoutData, ...data }, { payload })=>({
            ...data,
            apiTimeoutData: [
                ...apiTimeoutData,
                payload
            ].slice(-10)
        }), {
        apiTimeoutData: []
    })
];
